import CategoryPage from '../components/CategoryPage';

export default function Documentaries() {
  return <CategoryPage type="documentary" title="Documentaries" />;
}
